import { render, staticRenderFns } from "./barGradient.vue?vue&type=template&id=6456e7f4&"
import script from "./barGradient.vue?vue&type=script&lang=js&"
export * from "./barGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "barGradient.vue"
export default component.exports